import classNames from "classnames";
import styles from "./AscAnalyticsPillarTitleSubtitleCard.module.scss";

export type AscTitleSubtitleCardProps = {
  title: string;
  subtitle: string;
  titleClass?: string;
  subtitleClass?: string;
  className?: string;
};

export default function AscAnalyticsPillarTitleSubtitleCard({
  title,
  subtitle,
  className,
  titleClass,
  subtitleClass,
}: AscTitleSubtitleCardProps) {
  return (
    <div
      data-testid="asc-title-subtitle-card"
      className={classNames(styles.ground, className)}
    >
      <span className={classNames(styles.title, titleClass)}>{title}</span>
      <span className={classNames(styles.subtitle, subtitleClass)}>
        {subtitle}
      </span>
    </div>
  );
}
